// ============================================
// PhysDialog — modal con el look de SuccessModal (.success-content)
// Para avisos (con check animado) y confirmaciones (sin check).
// ============================================

import React, { useEffect } from 'react';
import { lockScroll, unlockScroll } from 'utils/scrollLock';
import './account/SuccessModal.css';

const CheckIcon = () => (
  <svg className="success-check" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
    <circle className="success-check-circle" cx="26" cy="26" r="25" fill="none" />
    <path className="success-check-path" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
  </svg>
);

/**
 * primary / secondary: { label, onClick }. onClose: overlay y tecla ESC.
 */
export default function PhysDialog({
  isOpen,
  onClose,
  title,
  message,
  showCheck = false,
  primary,
  secondary,
}) {
  useEffect(() => {
    if (!isOpen) return undefined;
    lockScroll();
    return () => unlockScroll();
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      <div className="success-overlay" onClick={onClose} aria-hidden="true" />
      <div className="success-modal" role="dialog" aria-modal="true" aria-labelledby="phys-dialog-title">
        <div className="success-content">
          {showCheck && <CheckIcon />}
          <h2 id="phys-dialog-title" className="success-title">{title}</h2>
          {message && <p className="success-message">{message}</p>}
          <div className="success-actions">
            {primary && (
              <button type="button" className="success-btn success-btn-primary" onClick={primary.onClick}>
                {primary.label}
              </button>
            )}
            {secondary && (
              <button type="button" className="success-btn success-btn-secondary" onClick={secondary.onClick}>
                {secondary.label}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
